import MainLayout from "../layouts/MainLayout";
import WhatWeDoHero from "../components/WhatWeDoHero";
import ServicesSection from "../components/ServicesSection";
import WhyChooseUs from "../components/WhyChooseUs";

export default function WhatWeDo() {
    return (
        <MainLayout>
            <WhatWeDoHero />
            <ServicesSection />
            <WhyChooseUs />
        </MainLayout>
    );
}